import { useTranslation } from "react-i18next";

interface AcceptedMediaTypesHintProps {
  /** When false, only the image formats line is shown. */
  showVideo?: boolean;
  className?: string;
}

/** Accepted file format hints shown under image/video dropzones. */
export function AcceptedMediaTypesHint({
  showVideo = true,
  className,
}: AcceptedMediaTypesHintProps) {
  const { t } = useTranslation();

  return (
    <div className={`flex flex-col items-center gap-1 ${className ?? ""}`}>
      <span className="text-gray-600 text-xs text-center">
        {t("acceptedImageTypes")}
      </span>
      {showVideo && (
        <span className="text-gray-600 text-xs text-center">
          {t("acceptedVideoTypes")}
        </span>
      )}
    </div>
  );
}
